    
    // export default productSlice.reducer;
    import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
    import { db, storage } from "../../Firebase/firebaseConfig";
    import { collection, addDoc, getDocs, where, query, orderBy } from "firebase/firestore";
    import {deleteDoc, doc} from 'firebase/firestore';
    import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
    import { v4 as uuidv4 } from 'uuid';
    
    // Define types
    interface Product {
      id?: string;
      name: string;
      subtitle: string;
      category: string;
      casNumber: string;
      base64Image?: string;
      productDescription: string;
      productDetails: any[];
      image?: string;
      createdAt?: string;
      updatedAt?: string;
    }
    
    interface ProductState {
      categoryId: string | null;
      items: Product[];
      categoryProducts: Product[];
      loading: boolean;
      error: string | null;
    }
    
    // Fetch all products
    export const fetchProducts = createAsyncThunk<Product[]>(
      "products/fetchProducts",
      async () => {
        const productQuery = await query(collection(db, "products"),orderBy('updatedAt', 'desc'));
        const querySnapshot = await getDocs(productQuery);
        const products = querySnapshot.docs.map((doc) => {
          const data = doc.data();
          return ({ id: doc.id, ...data , createdAt: data.createdAt?.toDate()?.toLocaleString() || new Date()?.toLocaleString(), updatedAt: data.updatedAt?.toDate()?.toLocaleString() }) as Product; 
        }) as Product[];
    
        console.log("Fetched Products from Firebase:", products);
        return products;
      }
    );
    
    // Fetch products by category
    export const fetchProductsByCategory = createAsyncThunk<Product[], string>(
      "products/fetchProductsbycategory",
      async (categoryName: string) => {
        const q = query(
          collection(db, "products"),
          orderBy('updatedAt', 'desc'),
          where("category", "==", categoryName.toLowerCase())
        );
        const querySnapshot = await getDocs(q);
        const products = querySnapshot.docs.map((doc) => {
          const data = doc.data();
          return ({ id: doc.id, ...data , createdAt: data.createdAt?.toDate()?.toLocaleString() || new Date()?.toLocaleString(), updatedAt: data.updatedAt?.toDate()?.toLocaleString() }) as Product;
        }) as Product[];
        return products;
      }
    );
    
    // Add a product
    export const addProduct = createAsyncThunk<Product, Omit<Product, "id" | "image">>(
      "products/addProduct",
      async ({ name, category, subtitle, casNumber, productDetails, base64Image, productDescription }) => {
        try {
          const newProduct = { name, category, subtitle, productDetails, casNumber, image: base64Image, productDescription };
          const docRef = await addDoc(collection(db, "products"), newProduct);
          return { id: docRef.id, ...newProduct };
        } catch (error: any) {
          console.error("Error adding product:", error);
          throw new Error(error.message);
        }
      }
    );
    
     export const deleteProduct = createAsyncThunk<string, string>(
      "products/deleteProduct",
      async (productId: string) => {
        try{
          await deleteDoc(doc(db, "products", productId))
          return productId;
        }catch (error: any) {
          console.error("Error deleting Product", error)
          throw new Error(error.message);
        }
      }
     );
    // Initial State
    const initialState: ProductState = {
      categoryId: null,
      items: [],
      categoryProducts: [],
      loading: false,
      error: null,
    };
    
    // Product Slice
    const productSlice = createSlice({
      name: "products",
      initialState,
      reducers: {
        setCategoryId: (state, action: PayloadAction<string | null>) => {
          state.categoryId = action.payload;
        },
        setProducts: (state, action: PayloadAction<Product[]>) => {
          state.items = action.payload;
        },
        setCategoryProducts: (state, action: PayloadAction<Product[]>) => {
          state.categoryProducts = action.payload;
        },
      },
      extraReducers: (builder) => {
        builder
          .addCase(fetchProducts.pending, (state) => {
            state.loading = true;
            state.error = null;
          })
          .addCase(fetchProducts.fulfilled, (state, action: PayloadAction<Product[]>) => {
            state.loading = false;
            state.items = action.payload;
          })
          .addCase(fetchProducts.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || null;
          })
          .addCase(fetchProductsByCategory.pending, (state) => {
            state.loading = true;
            state.error = null;
          })
          .addCase(fetchProductsByCategory.fulfilled, (state, action: PayloadAction<Product[]>) => {
            state.loading = false;
            state.categoryProducts = action.payload;
          })
          .addCase(fetchProductsByCategory.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || null;
          })
          .addCase(addProduct.pending, (state) => {
            state.loading = true;
          })
          .addCase(addProduct.fulfilled, (state, action: PayloadAction<Product>) => {
            state.loading = false;
            state.items.push(action.payload);
          })
          .addCase(addProduct.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || null;
          })

          // delete product
          .addCase(deleteProduct.pending, (state) => {
  state.loading = true;
  state.error = null;
})
.addCase(deleteProduct.fulfilled, (state, action: PayloadAction<string>) => {
  state.loading = false;
  state.items = state.items.filter(product => product.id !== action.payload);
  state.categoryProducts = state.categoryProducts.filter(product => product.id !== action.payload);
})
.addCase(deleteProduct.rejected, (state, action) => {
  state.loading = false;
  state.error = action.error.message || null;
});

      },
    });
    
    export default productSlice.reducer;
    export const { setCategoryId, setProducts, setCategoryProducts } = productSlice.actions;